<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Factory Stock Movement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Factory Stock Movement Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Stock Movement",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      totals: {
        total_in: 0,
        total_out: 0,
        total_balance: 0,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "batch",
          sortable: true,
          label: "PRODUCTION BATCH",
        },
        {
          key: "typename",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "customer",
          sortable: true,
          label: "CUSTOMER",
        },
        {
          key: "from_quantity",
          sortable: true,
          label: "OLD QUANTITY",
        },
        {
          key: "qty_in",
          sortable: true,
          label: "QUANTITY IN",
        },
        {
          key: "qty_out",
          sortable: true,
          label: "QUANTITY OUT",
        },
        {
          key: "balance",
          sortable: true,
          label: "NEW QUANTITY",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "date_recorded",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        type: "",
        id: atob(this.$route.params.product),
        factory: atob(this.$route.params.factory),
        batch: '',
        product: '',
        category: '1',
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      types: [
        { name: "All Types", id: "" },
        { name: "Adding Product", id: 0 },
        { name: "Sale", id: 1 },
        { name: "Production Output", id: 2 },
        { name: "Reconciliation", id: 3 },
        { name: "Output Return", id: 4 },
        { name: "Customer Order", id: 5 },
      ],

      json_fields: {
        PRODUCT: "product",
        FROM_QUANTITY: "from_quantity",
        QUANTITY_IN: "qty_in",
        QUANTITY_OUT: "qty_out",
        STOCK_BALANCE: "balance",
        TYPE: "typename",
        DESCRIPTION: "description",
        MADE_BY: "user",
        DATE: "date",
        RECORDED_ON: "date_recorded"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  watch: {
    StockMovement(newVal) {
      if(newVal){
        this.tryFetchBatches();
      }      
    },

    MyUserPerm(newVal) {
      if(newVal){
        this.tryFetchBatches();
      }
    }
  },

  computed: {
    ...mapGetters("auth", ["MyUserPerm"]),
    ...mapGetters("factorystock", ["StockMovement", "FilterStatus", "FactoryProductionBatches"]),


    /**
     * Total no. of records
     */


    formattedProductionBatches() {
      const batches = Array.isArray(this.FactoryProductionBatches)
        ? this.FactoryProductionBatches
        : Array.isArray(this.FactoryProductionBatches?.data)
          ? this.FactoryProductionBatches.data
          : []

      return [
        { id: '', batch_no: 'Select Batch', date: '', input_quantity: '' },
        ...batches
      ].map(batch => ({
        ...batch,
        display_name: batch.input_quantity
          ? `${batch.batch_no ? batch.batch_no : batch.id} - ${batch.date} (INPUT-${batch.input_quantity})`
          : `${batch.batch_no}`
      }))
    },

    rows() {
      return this.StockMovement ? this.StockMovement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StockMovement ? this.StockMovement.length : 1;
  },
  methods: {
    ...mapActions({
      FetchMovements: "factorystock/fetchStockMovements",
      FetchFactoryProductionBatches: "factorystock/fetchFactoryProductionBatches",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterReport() {
      this.FetchMovements(this.data);
    },

    tryFetchBatches() {
      if (!this.MyUserPerm || this.MyUserPerm.attach_production_batch_on_sales != 1) {
        return;
      }

      if (!this.StockMovement || !this.StockMovement.length) {
        return;
      }
      if (this._batchesFetched) return;
      if (this.StockMovement?.[0]?.product_id) {
        this.data.product = this.StockMovement[0].product_id;
      }
      this.FetchFactoryProductionBatches(this.data);
      this._batchesFetched = true;
    }
  },
  updated() {
    if (this.StockMovement) {
      let total_in = 0;
      let total_out = 0;
      this.StockMovement.forEach((item) => {
        total_in = total_in + parseInt(item.qty_in);
        total_out = total_out + parseInt(item.qty_out);
      });
      this.totals.total_in = total_in;
      this.totals.total_out = total_out;
      this.totals.total_balance = total_in - total_out;
    }
  },

  created() {
    this.FetchMovements(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-3">
              <div class="col-md-6">
                <download-excel class="btn btn-primary" :data="StockMovement" :fields="json_fields"
                  :worksheet="'STOCK MOVEMENTS ON' + currentdate" type="csv"
                  :name="'Stock Movements Report for '+StockMovement[0].factoryname+'-'+StockMovement[0].product+' from ' + data.datefrom + ' to ' + data.dateto + '.xls'">
                   Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-md-6 mt-2">
                <button @click="$router.go(-1)" class="btn btn-primary btn-sm">
                  <i class="fas fa-arrow-circle-left"></i> Go Back
                </button>
              </div>
            </div>
            <div class="row">
              <h4>
                <center>{{ StockMovement[0].factoryname }} Factory Stock Movements Report for {{
                  StockMovement[0].product }}
                  from {{ data.datefrom }} to {{ data.dateto }}</center>
              </h4>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Movement Type</label>
                  <model-list-select :list="types ? types : []" v-model="data.type" option-value="id" option-text="name"
                    class="mb-3" placeholder="Select Type" @input="filterReport()">
                  </model-list-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="data.datefrom" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="data.dateto" class="form-control" />
                </div>
              </div>
              <div class="form-group col-md-3" v-if="MyUserPerm.attach_production_batch_on_sales">
                <label>Select Production Batch</label>
                <model-list-select :list="formattedProductionBatches" v-model="data.batch" option-value="id"
                  option-text="display_name" placeholder="Select Production Batch" @input="filterReport()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="StockMovement ? StockMovement : []" :fields="fields" responsive="sm"
                :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-4">
                  <h5>Total Qty In: <span class="text-danger">{{ (totals.total_in).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Qty Out: <span class="text-danger">{{ (totals.total_out).toLocaleString() }}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Balance: <span class="text-danger">{{ (totals.total_balance).toLocaleString() }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!StockMovement" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>
